module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-bepalend-voornaamwoord.json
// module id = 1297
// module chunks = 105819326753277